
export interface BlogPost {
  id: string;
  created_by: string;
  key: string;
  text: string;
  blog_url: string;
  url: string;
  last_downloaded_at: string;
  createdAt: string;
  updatedAt: string;
}

export const fetchBlogPosts = async (): Promise<BlogPost[]> => {
  try {
    const response = await fetch('/blogs.json');
    if (!response.ok) {
      throw new Error(`Failed to fetch blogs: ${response.statusText}`);
    }
    const data = await response.json();
    return data.blogs || [];
  } catch (error) {
    console.error('Error fetching blog posts form S3/JSON:', error);
    // Fallback: If network/json fails, return empty array.
    // The UI should handle empty state or loading state.
    return [];
  }
};

export const fetchRecentBlogs = async (limit: number = 2): Promise<BlogPost[]> => {
    try {
        const blogs = await fetchBlogPosts();
        // Sort by createdAt descending (newest first) just to be safe, 
        // though our add-blog script already unshifts to top.
        const sortedBlogs = blogs.sort((a, b) => {
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
        return sortedBlogs.slice(0, limit);
    } catch (error) {
        console.error('Error fetching recent blogs:', error);
        return [];
    }
}